import { ComponentStyleConfig } from '@chakra-ui/react';

export const Heading: ComponentStyleConfig = {
  baseStyle: {
    fontSize: '1.562rem',
    fontWeight: '500',
  },
};
